import { useMutation, useQuery } from '@apollo/client';
import { AppContext, toast, AccessControl } from '@nile/components';
import { ADD_NOTE, GET_CONVERSATION_FEEDS, GET_NOTES } from '@nile/graphql';
import { NoteBubble } from '@nile/mangifera/src/Components/Chat';
import { ActionContainer } from '@nile/mangifera/src/Containers/ChatContainers';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import React, { Component, useContext } from 'react';
import { ChatFeed } from 'react-bell-chat';

import styled from 'styled-components';

const StyledConversation = styled.div`
  height: 91vh;
  background: #ecf0f1;
  border-bottom: 1px solid #e7e7e7;

  .Polaris-Card {
    margin: 20px;
  }
`;

class NoteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: props.notes,
      editor: ''
    };
  }

  onMessageSubmit = (message, e) => {
    const { ticket, addNote, user } = this.props;
    const { notes } = this.state;
    const note = { content: message, ticket: { ticketId: ticket.ticketId } };

    addNote({
      variables: note,
      input: note
    }).then(({ data }) => {
      const { addNote } = data;
      this.setState((prevState) => ({
        notes: [
          ...notes,
          {
            message: addNote.content,
            id: addNote.noteId,
            isSend: true,
            authorId: addNote.addedBy.userId,
            user: addNote.addedBy
          }
        ]
      }));
    });
  };

  render() {
    const { notes, editor } = this.state;
    const { authors, user, onMessageSubmit, ticket } = this.props;
    return (
      <div>
        <ChatFeed
          customChatBubble={NoteBubble}
          messages={notes}
          authors={authors}
          yourAuthorId={user.userId}
        />
        <AccessControl
          roleToCheck="ticketingAddNotes.allow"
          render={
            <ActionContainer
              template={editor}
              ReadOnly={true}
              onMessageSubmit={this.onMessageSubmit}
              module="TICKET_NOTE"
              details={{
                operation: 'CREATE',
                ticketId: ticket.ticketId
              }}
            />
          }
        />
      </div>
    );
  }
}

function NoteContainer(props) {
  const context = useContext(TicketContext);
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const { ticket } = props;

  const { loading, error, data } = useQuery(GET_NOTES, {
    variables: { ticketId: ticket.ticketId }
  });

  const [addNote, { loading: noteLoading, error: noteError }] = useMutation(
    ADD_NOTE,
    {
      onCompleted({ addNote }) {
        toast('success', 'New node created successfully');
      },
      update(cache, { data }) {
        const { ticketId } = data?.addNote?.ticket;

        let note = cache.readQuery({
          query: GET_NOTES,
          variables: { ticketId }
        });
        var notes = [...note.getNotes, data.addNote];

        cache.writeQuery({
          query: GET_NOTES,
          variables: { ticketId },
          data: {
            getNotes: notes
          }
        });

        let feed = cache.readQuery({
          query: GET_CONVERSATION_FEEDS,
          variables: { ticketId }
        });
        var feeds = [...feed.getTicketFeeds, data.addNote];

        cache.writeQuery({
          query: GET_CONVERSATION_FEEDS,
          variables: { ticketId },
          data: {
            getTicketFeeds: feeds
          }
        });
      }
    }
  );

  if (loading) return <p>Loading ...</p>;

  const authors = [];
  const notes = data.getNotes.map((note) => {
    authors.push({
      name: note.addedBy.firstName + '  ' + note.addedBy.lastName
    });
    return {
      message: note.content,
      id: note.noteId,
      isSend: true,
      authorId: note.addedBy.userId,
      user: note.addedBy
    };
  });

  return (
    <StyledConversation>
      <NoteList
        notes={notes}
        authors={authors}
        user={user}
        addNote={addNote}
        {...props}
      ></NoteList>
    </StyledConversation>
  );
}

export default NoteContainer;
